<template>
  <div class="tw-dialog-box" v-if="isShowDialog">
    <!-- <div style="background: rgb(255, 255, 255)">dialog box >> {{changeDialog}}</div> -->
    <component :is="changeDialog" :type="dialogType"></component>
  </div>
</template>

<script>
import StorageDialog from "./child/storageDialog";
import InspectionDialog from "./inspectionDialogContent/inspectionDialog";
import LookActivity from "./venueRental/lookActivity";
import Remit from "./venueRental/remit";

export default {
  name: "dialogBox",
  data() {
    return {
      typeObj: {
        // Storage system
        picking: "storage", // Material requisition
        replenishment: "storage", // Replenishment
        transfer: "storage", // Transfer
        change: "storage", // Change
        signed: "storage", // Approval
        // Inspection system
        callRepairNSigned: "inspection", // Inspection repair request - unprocessed approval
        callRepairPSigned: "inspection", // Inspection repair request - processing approval
        appliedAsSigned: "inspection", // Work order approval
        delaySigned: "inspection", // Delayed completion date approval
        appliceCallSigned: "inspection", // From work order to approval 2
        tasktingSigned: "inspection", // From work order to approval 2
        lookActivity: "lookActivity",
        remit: "remit" // Venue export dialog
      }
    };
  },
  computed: {
    changeDialog() {
      if (this.typeObj[this.dialogType] == "storage") {
        return StorageDialog;
      } else if (this.typeObj[this.dialogType] == "lookActivity") {
        return LookActivity;
      } else if (this.typeObj[this.dialogType] == "remit") {
        return Remit;
      } else {
        return InspectionDialog;
      }
    },
    dialogType() {
      return this.$store.state.dialogType;
    },
    isShowDialog() {
      return this.$store.state.isShowDialog;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.tw-dialog-box {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialogBox.vue